import axios from "axios";
import { API_URL } from "const/constants";

export const getProviderUniversityId = (provider) =>
  provider?.universityId ?? provider?.universityDetail?.id ?? provider?.providerId ?? null;

export const getProviderName = (provider) =>
  provider?.universityName ?? provider?.universityDetail?.name ?? provider?.name ?? "";

export const findProviderByUniversityId = (providerList = [], universityId) =>
  providerList.find((item) => Number(getProviderUniversityId(item)) === Number(universityId));

export const ensureProviderAccount = async (provider, refetchProvider) => {
  if (provider?.accountProviderId) return provider;

  const universityId = getProviderUniversityId(provider);
  if (!universityId) {
    throw new Error("Provider university is missing.");
  }

  const response = await axios.post(`${API_URL}/accounts/provider`, {
    providerId: universityId,
    accountDetails: [],
  });
  const created = response?.data?.data || {};
  refetchProvider?.();

  return {
    ...provider,
    accountProviderId: created?.accountProviderId ?? created?.id,
    universityId,
    universityName: getProviderName(provider),
    hasProviderAccount: true,
  };
};
